export default {
    flash: '',
    flashKey: ''
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Flash/state.js